import { Component, OnInit, Input } from '@angular/core';
import { MappingsService } from '../../services/mappings.service';
import { LectionaryItemMap, Proper } from 'app/objects';
import { Service } from '../../services/service.service';
import { LectionaryItemType } from '../../services/lectionary-item-type.service'; 
import { MapOperator } from 'rxjs/internal/operators/map';
import { LiturgyType } from '../../services/liturgy-type.service';
import { LectionaryItemName } from '../../services/lectionary-item-name.service';
import { LectionarySource } from '../../services/lectionary-source.service';
import { LectionaryYear } from '../lectionary-year/lectionary-year.component';
import { LectionaryTrack } from '../lectionary-track/lectionary-track.component';
import { LectionaryItem } from '../../services/lectionary-item.service';

@Component({
  selector: 'app-mappings',
  templateUrl: './mappings.component.html',
  styleUrls: ['./mappings.component.css']
})
export class MappingsComponent implements OnInit {

  public isLoading: Boolean;

  @Input() serviceId: string;
  @Input() properId: string;
  
  @Input() isServiceUsingProperMap: boolean = false;

  public mappings: LectionaryItemMap[];
  public isProper = false;

  public filterModel: MappingFilterModel;
  
  public activeMapToEdit: LectionaryItemMap;

  constructor(public mappingSvc: MappingsService) { }

  ngOnInit() {

    this.filterModel = new MappingFilterModel();

    if (this.properId != null) {
      this.isProper = true;
    }
    else 
    {
      this.isProper = false;
    }
    
    this.loadMappings();
  }



  public loadMappings() {
    console.log("Load Mappings");
 
    this.isLoading = true;
    if (this.serviceId != null) {
 
      this.mappingSvc.getMappings(this.serviceId).then(
        (data)=> {
          console.log("Mappings assigned for service", data);
          this.mappings = data; 
          this.isLoading = false;
        }
      )

    } else if (this.properId != null) {

      this.mappingSvc.getMappingsForProper(this.properId).then(
        (data)=> {
          console.log("Mappings assigned for proper", data);
          this.mappings = data;
          this.isLoading = false;
        }
      )

    }
  }

  public addMapping() {
    console.log("add mapping"); 
    var map = new LectionaryItemMap(); 
    map.LectionaryItemType = new LectionaryItemType();
    map.LectionaryItemType.Id = null; 
    map.LiturgyType = new LiturgyType();
    map.LectionaryItemName = new LectionaryItemName();
    map.LectionarySource = new LectionarySource();
    map.LectionaryYear = new LectionaryYear();
    map.LectionaryTrack = new LectionaryTrack(); 

    if (this.serviceId != null) {
      map.Service = new Service();
      map.Service.Id = this.serviceId;
    }

    if (this.properId != null) {
      map.Proper = new Proper();
      map.Proper.Id = this.properId;
    }

    this.activeMapToEdit = map;
  }

  public editMapping(mapping: LectionaryItemMap) {
    console.log("edit mapping", mapping);
    this.activeMapToEdit = mapping;
  } 
 

  public editMappingClosed() {
    this.activeMapToEdit = null;
    this.loadMappings();
  }

  private deleteMapping(mapping: LectionaryItemMap) {

    console.log("delete", mapping);

    if (confirm("Are you sure you want to delete this mapping?")) {

      this.mappingSvc.delete(mapping).then(
        () => { 
          console.log("Map deleted");
          this.loadMappings();
        }
      )

    }

  }

}

export class MappingFilterModel {
  public Year: string;
  public Date: Date;
}
